import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    Box,
} from "@mui/material";
import { toast } from "react-toastify";

const ConfirmMobileDialog = ({ open, onClose, onConfirm = null, mobile = null }) => {
    const [confirmMobile, setConfirmMobile] = useState("");

    const handleContinue = () => {
        if (confirmMobile !== mobile) {
            toast.error("Mobile number does not match");
            return;
        }
        onConfirm();
        setConfirmMobile("");
    };

    const handleClose = () => {
        setConfirmMobile("");
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Confirm Mobile Number
                </Typography>

                <TextField
                    fullWidth
                    variant="standard"
                    placeholder="Please Re-enter Mobile Number"
                    value={confirmMobile}
                    onChange={(e) => setConfirmMobile(e.target.value)}
                    inputProps={{ maxLength: 10 }}
                />
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={handleClose}
                    sx={{
                        color: "#d32f2f",
                        fontWeight: 500,
                    }}
                >
                    CANCEL
                </Button>

                <Button
                    variant="contained"
                    onClick={handleContinue}
                    sx={{
                        textTransform: "uppercase",
                        px: 3,
                    }}
                    disabled={confirmMobile.length !== 10}
                >
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmMobileDialog;
